import { render, staticRenderFns } from "./SpeechToText.vue?vue&type=template&id=57cc8420&"
import script from "./SpeechToText.vue?vue&type=script&lang=js&"
export * from "./SpeechToText.vue?vue&type=script&lang=js&"
import style0 from "./SpeechToText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
